import { render, staticRenderFns } from "./business.vue?vue&type=template&id=06b0ebab&scoped=true&"
import script from "./business.vue?vue&type=script&lang=js&"
export * from "./business.vue?vue&type=script&lang=js&"
import style0 from "./business.vue?vue&type=style&index=0&id=06b0ebab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0ebab",
  null
  
)

export default component.exports